/**
 * EVERY PAGE A SHOPPER FROM AN AD OPENS IS A STEP OF THEIR JOURNEY (utils/shopJourney.js).
 *
 * Mounted once, inside the router and outside the routes, beside MetaPixelPageViews: each change of
 * page is told to the journey, and so is a page the browser brings back from its back-forward
 * cache. What counts as a change is the page itself — its path, and on a product page the variant
 * a link names; a shop filter that rewrites the query string is the same page. Whether anything is
 * sent is the journey's to decide: nothing is, for a visit that did not come from an ad. The
 * movement recorder beside it keeps every visitor's scrolls, taps and dwell on the same pages.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { journeyPageChange, journeyPageOf } from '../../utils/shopJourney';
import { movementPageChange } from '../../utils/shopMovement';

export default function ShopJourneyPages() {
  const { pathname, search } = useLocation();
  const where = journeyPageOf(pathname, search);
  const pageKey = `${pathname}|${where?.pageType ?? ''}|${where?.variantId ?? ''}`;

  useEffect(() => {
    journeyPageChange({ pathname, search });
    // And where every shopper went, how far and what they tapped there (utils/shopMovement.js).
    movementPageChange({ pathname, search });
    // One step per page: `search` is read when the page changes, not a reason for a new one.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageKey]);

  useEffect(() => {
    const onShow = (event) => {
      if (!event.persisted) return;
      journeyPageChange({ pathname: window.location.pathname, search: window.location.search });
      movementPageChange({ pathname: window.location.pathname, search: window.location.search, restored: true });
    };
    window.addEventListener('pageshow', onShow);
    return () => window.removeEventListener('pageshow', onShow);
  }, []);

  return null;
}
